import { Outlet } from 'react-router-dom';

export default function Documents() {
    return (
        <Outlet />
    )
}
